// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__b0mFB","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__bk-SO"};